import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { IconValuesType } from '../icon/icon.component.types'
import { CommonModule } from '@angular/common'
import { IconComponent } from '../icon/icon.component'
import {
  TypographyComponent,
  TypographyVariant,
} from '../typography/typography.component'

export type BadgeVariant =
  | 'neutral'
  | 'primary'
  | 'secondary'
  | 'information'
  | 'error'
  | 'warning'
  | 'success'

export type BadgeSize = 'base' | 'large'

export type BadgeIndicator = 'none' | 'dot' | 'icon'

@Component({
  selector: 'hyperkit-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  standalone: true,
  imports: [CommonModule, IconComponent, TypographyComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  @Input() variant: BadgeVariant = 'neutral'
  @Input() indicator: BadgeIndicator = 'none'
  @Input() icon: IconValuesType = 'check'
  @Input() size: BadgeSize = 'base'
  @Input() text = ''

  // get typographyVariant(): TypographyVariant {
  //   return this.size === 'large' ? 'label1' : 'label2';
  // }
}
